import { render, staticRenderFns } from "./iconBolt.vue?vue&type=template&id=aeb6a960"
import script from "./iconBolt.vue?vue&type=script&lang=js"
export * from "./iconBolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports